export default __webpack_public_path__ + "static/media/emptyCatalog.d1683424.jpg";